/**
 * Max ancestor-chain length allowed when adding a subtask (see `prisma.task.calculateSubTask`).
 * Previously 3; increasing allows deeper task trees. Must stay in sync with nested `include`
 * depth for task queries and duplicate-project flows.
 */
export const MAX_SUBTASK_ANCESTOR_DEPTH = 10;

/**
 * How many levels of nested `subtasks` to load in Prisma includes (root + descendants).
 * Should be >= MAX_SUBTASK_ANCESTOR_DEPTH so UI receives full trees after the limit change.
 */
export const SUBTASKS_QUERY_NEST_DEPTH = MAX_SUBTASK_ANCESTOR_DEPTH;

/** Max task duration in days (create, update, WBS import). */
export const TASK_MAX_DURATION_DAYS = 5000;
